export const DEVICE_SIZE = {
  LAPTOP: '1025px',
  LAPTOP_L: '1440px',
  LAPTOP_M: '1140px',
  LAPTOP_S: '1040px',
  MOBILE_L: '425px',
  MOBILE_M: '375px',
  MOBILE_S: '320px',
  TABLET: '768px',
  TABLET_L: '868px',
  TABLET_S: '520px',
}

export const TYPES_DEVICE_SIZE = {
  LAPTOP: '1024px',
  MOBILE: '430px',
  TABLET: '745px',
}
